import React from "react";
import Header from "../layouts/header";
import Sidebar from "../layouts/sidebar";
import Layout from "../layouts/layout";
import PageHeading from "../layouts/pageHeading";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link as MuiLink, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { cssProperties } from "../utils/commonCssProperties";
import Cookies from "js-cookie";
import Index from "../components/CapCategoryDocument";

export default function CapCategoryDocument() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const naviagte = useNavigate();

  const handleClick = () => {
    if (page === "addcapcategorydocument" || page === "updatecapcategorydocument") {
      naviagte(`/${Cookies.get("mhet_mst_project")}/category-documentlist`);
    }
  };

  const breadcrumbs = [
    <MuiLink
      underline="hover"
      key="1"
      component={NavLink}
      to={`/${Cookies.get("mhet_mst_project")}/home`}
      sx={{
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Dashboard
    </MuiLink>,
    <Typography
      key="3"
      color="text.primary"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: page === "category-documentlist"  ? "bold" : 400,
        lineHeight: "20px",
        letterSpacing: "0.1px",
        ":hover":{
          textDecoration: page === "category-documentlist" ? "none" : "underline",
          cursor : page === "category-documentlist" ? "none" : "pointer"
        }
      }}
      onClick={page === "category-documentlist" ? undefined : handleClick}
    >
     CAP Category Document {page === "category-documentlist" && <MdKeyboardArrowDown size={16} /> }
    </Typography>,
  ];

  if (page === "addcapcategorydocument") {
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Add Cap Category Document<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }else if (page === "updatecapcategorydocument"){
    breadcrumbs.push(
      <Typography
        key="2"
        color="text.primary"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          color: cssProperties?.fontcolor?.primary,
          fontSize: "14px",
          fontWeight: "bold",
          lineHeight: "20px",
          letterSpacing: "0.1px",
        }}
      >
        Update Cap Category Document<MdKeyboardArrowDown size={16} />
      </Typography>
    );
  }

  return (
    <>
      <Header breadcrumbs={breadcrumbs}/>
      <Sidebar />
      <Layout>
        <PageHeading
          title={
            page === "category-documentlist"
              ? "CAP Category Document Master"
              : page === "addcapcategorydocument"
              ? "Add CAP Category Document"
              : page === "updatecapcategorydocument"
              ? "Update CAP Category Document"
              : null
          }
        />
        
        <Index />
      </Layout>
    </>
  );
}
